// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';
// Importamos getFirestore para evitar errores de inicialización duplicada en HMR
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

// Tu configuración de Firebase para esta app web
const firebaseConfig = {
  apiKey: "AIzaSyDWV6TuPxztAIRjSWQiE2Zx5xjrGLjIrRg",
  authDomain: "gestionpagosfracc.firebaseapp.com",
  projectId: "gestionpagosfracc",
  storageBucket: "gestionpagosfracc.firebasestorage.app",
  messagingSenderId: "257908171605",
  appId: "1:257908171605:web:270b03f0bf25cf2fa845dc",
  measurementId: "G-0QQQHGKQE5"
};

// Inicializar Firebase
export const app = initializeApp(firebaseConfig);

// Exportar los servicios que usaremos en la app
// Habilitamos la persistencia persistente (IndexedDB) con soporte multi-pestaña de forma segura
let dbInstance;
try {
    dbInstance = initializeFirestore(app, {
        localCache: persistentLocalCache({
            tabManager: persistentMultipleTabManager()
        })
    });
    console.log('✅ Firestore inicializado con persistencia');
} catch (error) {
    console.warn('⚠️ [Firebase] Fallo al inicializar con persistencia (posible recarga en caliente):', error.message);
    dbInstance = getFirestore(app);
}

export const db = dbInstance;

export const auth = getAuth(app);
// Configurar persistencia automática para móvil (Firebase Auth mantiene sesión automáticamente)
// La persistencia se maneja en el componente Login con setPersistence
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

// PRODUCCIÓN: conectado a Firebase Cloud
console.log(' Conectado a Firebase PRODUCCIÓN y modo offline (persistencia) habilitado');
